import { render, staticRenderFns } from "./nav-header.vue?vue&type=template&id=6a5b6da0"
import script from "./nav-header.vue?vue&type=script&lang=js"
export * from "./nav-header.vue?vue&type=script&lang=js"
import style0 from "./nav-header.vue?vue&type=style&index=0&id=6a5b6da0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports